/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskReportItemResponse
 */
export interface ExecRiskReportItemResponse {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReportItemResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskReportItemResponse
     */
    report_url?: string;
}

/**
 * Check if a given object implements the ExecRiskReportItemResponse interface.
 */
export function instanceOfExecRiskReportItemResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function ExecRiskReportItemResponseFromJSON(json: any): ExecRiskReportItemResponse {
    return ExecRiskReportItemResponseFromJSONTyped(json, false);
}

export function ExecRiskReportItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskReportItemResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': json['process_id'],
        'report_url': !exists(json, 'report_url') ? undefined : json['report_url'],
    };
}

export function ExecRiskReportItemResponseToJSON(value?: ExecRiskReportItemResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
        'report_url': value.report_url,
    };
}

